import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { orderQrUrl, toQrDataUrl } from '@app/utils/orderQr';

interface OrderQrCodeProps {
  orderCode: string;
  size?: number;
}

/** Mã QR của đơn (link trang xử lý nhanh) — bấm để phóng to cho điện thoại quét. */
const OrderQrCode: React.FC<OrderQrCodeProps> = ({ orderCode, size = 56 }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let ignore = false;
    toQrDataUrl(orderQrUrl(orderCode), 480)
      .then((dataUrl) => {
        if (!ignore) setSrc(dataUrl);
      })
      .catch(() => {
        if (!ignore) setSrc(null);
      });
    return () => {
      ignore = true;
    };
  }, [orderCode]);

  if (!src) return null;

  return (
    <>
      <button
        type="button"
        title="Phóng to mã QR đơn hàng"
        onClick={() => setOpen(true)}
        className="tw-cursor-zoom-in tw-border-0 tw-bg-transparent tw-p-0 tw-leading-none"
      >
        <img src={src} alt={`QR ${orderCode}`} width={size} height={size} />
      </button>
      <Modal open={open} footer={null} centered width={360} title={`Mã QR đơn ${orderCode}`} onCancel={() => setOpen(false)}>
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
          <img src={src} alt={`QR ${orderCode}`} width={280} height={280} />
          <span className="tw-text-sm tw-text-on-surface-variant">Quét bằng camera điện thoại để mở nhanh đơn</span>
        </div>
      </Modal>
    </>
  );
};

export default OrderQrCode;
